export const cities = ['Cidade 1', 'Cidade 2', 'Cidade 3', 'Cidade 4'];

export const ufs = ['SE', 'RJ', 'ES', 'SP', 'MG'];
